// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import LoginOverview from './LoginOverview';
// Renamed variants
import LoginClassicMinimal from './LoginClassicMinimal';
import LoginHeroImage from './LoginHeroImage';
import LoginDarkMode from './LoginDarkMode';
// Existing variants
import LoginSplit from './LoginSplit';
import LoginGradient from './LoginGradient';
import LoginModern from './LoginModern';
import LoginAnimated from './LoginAnimated';
import LoginIllustrated from './LoginIllustrated';
import LoginParallax from './LoginParallax';
import LoginMinimal3D from './LoginMinimal3D';
import LoginSplitScreen from './LoginSplitScreen';
// New variants
import LoginCenteredCard from './LoginCenteredCard';
import LoginGlassmorphism from './LoginGlassmorphism';
import LoginMobileAppStyle from './LoginMobileAppStyle';
import LoginSocialLogin from './LoginSocialLogin';
import LoginSidebar from './LoginSidebar';
import LoginCarouselOnboarding from './LoginCarouselOnboarding';

export default function LoginRoutes() {
  return (
    <Routes>
      <Route index element={<LoginOverview />} />
      {/* Renamed routes */}
      <Route path="classic-minimal" element={<LoginClassicMinimal />} />
      <Route path="hero-image" element={<LoginHeroImage />} />
      <Route path="dark-mode" element={<LoginDarkMode />} />
      {/* Existing routes */}
      <Route path="split" element={<LoginSplit />} />
      <Route path="gradient" element={<LoginGradient />} />
      <Route path="modern" element={<LoginModern />} />
      <Route path="animated" element={<LoginAnimated />} />
      <Route path="illustrated" element={<LoginIllustrated />} />
      <Route path="parallax" element={<LoginParallax />} />
      <Route path="minimal3d" element={<LoginMinimal3D />} />
      <Route path="splitscreen" element={<LoginSplitScreen />} />
      {/* New routes */}
      <Route path="centered-card" element={<LoginCenteredCard />} />
      <Route path="glassmorphism" element={<LoginGlassmorphism />} />
      <Route path="mobile-app-style" element={<LoginMobileAppStyle />} />
      <Route path="social-login" element={<LoginSocialLogin />} />
      <Route path="sidebar" element={<LoginSidebar />} />
      <Route path="carousel-onboarding" element={<LoginCarouselOnboarding />} />
    </Routes>
  );
}
